import * as React from 'react';
import { type MenuGroup } from './MenuGroup.tsx';

export interface IRichTextMenuScopeContext {
  /**
   * Gruppi di pulsanti che NON devono essere renderizzati dagli editor
   * rich text presenti nel sottoalbero, anche se inclusi nel preset
   * passato via `menus`.
   *
   * È il contraltare sottrattivo di `extendedMenu`: quello aggiunge un
   * pulsante fuori dai preset, questo ne toglie uno dai preset condivisi
   * limitatamente a un sottoalbero (es. l'Editor Light, dove il colore
   * non è previsto).
   */
  exclude?: MenuGroup[];
}

export const RichTextMenuScopeContext =
  React.createContext<IRichTextMenuScopeContext>({});

export const useRichTextMenuExclude = () =>
  React.useContext(RichTextMenuScopeContext).exclude;
